import { Routes } from '@angular/router';
import { Page404Component } from './extrapages/page404/page404.component';
import { VerticalComponent } from './layouts/vertical/vertical.component';
import { authGuard } from './core/guards/auth.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule),
  },
  {
    path: 'pay',
    loadChildren: () => import('./extrapages/moyasar/moyasar.module').then(m => m.MoyasarModule),
  },
  {
    path: 'public-invoice',
    loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule),
    data: { publicInvoice: true },
  },
  {
    path: '',
    component: VerticalComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [authGuard],
  },
  {
    path: 'account/interested-customer-registration',
    loadComponent: () => import(
      './account/auth/interested-customer-registration/interested-customer-registration.component'
    ).then(m => m.InterestedCustomerRegistrationComponent),
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(
      (m) => {
        return m.AccountModule;
      },
      (err) => {
        console.error('Failed to load AccountModule:', err); // Debug
        throw err;
      }
    ),
  },
  {
    path: 'zamalek-academy',
    loadChildren: () => import(
      './zamalek/zamalek.module').then(m => m.ZamalekModule),
  },
  {
    path: 'academy-registration',
    loadChildren: () => import(
      './zamalek/zamalek.module').then(m => m.ZamalekModule),
  },
  {
    path: 'academy',
    loadChildren: () => import('./pages/academy/academy.module').then(
      (m) => {
        return m.AcademyModule;
      },
      (err) => {
        console.error('Failed to load AcademyModule:', err); // Debug
        throw err;
      }
    ),
  },
  {
    path: 'loader',
    loadComponent: () => import('./shared/components/spinner/spinner.component').then(m => m.SpinnerComponent)
  },

  {
    path: '**',
    component: Page404Component
  },
];
